import { fetch } from 'common/ajax';

const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;

const getOrganizationByAliasUrl = alias =>
  `${AUTH_BASE_URL}/organizations/alias/${alias}`;

export const fetchOrganizationByAlias = alias =>
  fetch(getOrganizationByAliasUrl(alias));



// WEBPACK FOOTER //
// ./src/common/authAjax.js